﻿import { format } from "date-fns";
import { CreditCard, Receipt } from "lucide-react";

export function BillingHistory({
  billingInfo,
  loadingBilling,
}: {
  billingInfo: any;
  loadingBilling: boolean;
}) {
  if (loadingBilling) {
    return (
      <div className="bg-slate-900 border border-slate-800 p-6 rounded-2xl shadow-lg text-slate-400 text-sm">
        Carregando faturamento...
      </div>
    );
  }

  if (!billingInfo?.hasSubscription) return null;

  return (
    <div className="bg-slate-900 border border-slate-800 p-6 rounded-2xl shadow-lg space-y-6 mt-6">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 border-b border-slate-800 pb-4">
        <div>
          <h2 className="text-xl font-bold text-white flex items-center gap-2">
            <Receipt className="text-blue-500" size={20} />
            Faturamento e Mensalidades
          </h2>
          <p className="text-xs text-slate-400 mt-1">
            Visualize o histórico de faturas da sua assinatura.
          </p>
        </div>
        {billingInfo.nextInvoice && (
          <a
            href={billingInfo.nextInvoice.invoiceUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="px-4 py-2 bg-emerald-600 hover:bg-emerald-500 text-white font-bold text-xs rounded-lg transition-all active:scale-95 flex items-center gap-2 shadow-lg shadow-emerald-950/20"
          >
            <CreditCard size={14} /> Pagar Próxima Fatura (R${" "}
            {billingInfo.nextInvoice.value.toFixed(2)})
          </a>
        )}
      </div>

      <div className="overflow-x-auto">
        <table className="w-full text-sm text-left text-slate-300">
          <thead className="text-xs uppercase bg-slate-950/40 text-slate-400 border-b border-slate-800">
            <tr>
              <th className="px-4 py-3">Vencimento</th>
              <th className="px-4 py-3">Valor</th>
              <th className="px-4 py-3">Método</th>
              <th className="px-4 py-3">Status</th>
              <th className="px-4 py-3 text-right">Fatura</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-800/60">
            {billingInfo.payments.length === 0 ? (
              <tr>
                <td colSpan={5} className="text-center py-6 text-slate-500">
                  Nenhuma fatura encontrada.
                </td>
              </tr>
            ) : (
              billingInfo.payments.map((payment: any) => (
                <tr
                  key={payment.id}
                  className="hover:bg-slate-800/10 transition-colors"
                >
                  <td className="px-4 py-3.5 font-medium text-slate-200">
                    {format(new Date(payment.dueDate), "dd/MM/yyyy")}
                  </td>
                  <td className="px-4 py-3.5 font-semibold text-slate-100">
                    R$ {payment.value.toFixed(2)}
                  </td>
                  <td className="px-4 py-3.5 text-xs text-slate-400">
                    {payment.billingType === "PIX"
                      ? "PIX"
                      : payment.billingType === "CREDIT_CARD"
                        ? "Cartão"
                        : "Boleto"}
                  </td>
                  <td className="px-4 py-3.5">
                    <span
                      className={`inline-flex px-2 py-0.5 rounded-full text-xs font-semibold ${
                        payment.status === "CONFIRMED" ||
                        payment.status === "RECEIVED"
                          ? "bg-emerald-500/10 text-emerald-400 border border-emerald-500/25"
                          : payment.status === "OVERDUE"
                            ? "bg-red-500/10 text-red-400 border border-red-500/25"
                            : "bg-amber-500/10 text-amber-400 border border-amber-500/25"
                      }`}
                    >
                      {payment.status === "CONFIRMED" ||
                      payment.status === "RECEIVED"
                        ? "Pago"
                        : payment.status === "OVERDUE"
                          ? "Atrasado"
                          : "Pendente"}
                    </span>
                  </td>
                  <td className="px-4 py-3.5 text-right">
                    {payment.invoiceUrl && (
                      <a
                        href={payment.invoiceUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-400 hover:text-blue-300 font-semibold text-xs"
                      >
                        Visualizar
                      </a>
                    )}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
